<template>
  <SfButtonDs
    :variant="variant"
    :class="extraClasses"
    :disabled="disabled"
    data-walkthrough-id="new-remark-button"
    @click="openModal"
    >{{ I18n.t('communication.add_remark') }}</SfButtonDs
  >
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useI18n from '../../composables/use-I18n'
import useOpenRemarkModal from '../../composables/use-open-remark-modal'
import { isCurrentWorkflowLocked } from '@app/adapters/silverfin'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'

defineOptions({
  name: 'NewRemarkButton',
})

type Variant = 'primary' | 'secondary' | 'tertiary' | 'danger' | 'ai'

interface Props {
  ownerType?: string
  ownerId?: string | number
  ledgerId?: string | number
  ledgerLabel?: string
  variant?: Variant
  extraClasses?: string
  hidePeriodSelector?: boolean
  selectedTagIds?: number[]
  modalSize?: string
  isClientMeetingRemark?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
})

const I18n = useI18n()

const disabled = isCurrentWorkflowLocked()

const selectedTagIds = computed(() => props.selectedTagIds ?? [])

const openModal = (): void => {
  openRemarkModal()
}

const openRemarkModal = useOpenRemarkModal({
  ownerType: computed(() => props.ownerType),
  ownerId: computed(() => props.ownerId),
  ledgerId: computed(() => props.ledgerId),
  ledgerLabel: computed(() => props.ledgerLabel),
  hidePeriodSelector: computed(() => props.hidePeriodSelector),
  selectedTagIds: selectedTagIds,
  modalSize: computed(() => props.modalSize),
  isClientMeetingRemark: computed(() => props.isClientMeetingRemark),
})
</script>
